import axios from 'axios';
import { useMutation } from 'react-query';
import type { AttributionPayload } from 'src/modules/AppsFlyer/attribution';

export const useReportAttribution = () =>
  useMutation<void, unknown, AttributionPayload>({
    mutationFn: async payload => {
      await axios.post('/api/user/attribution', payload);
    },
  });
